import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#F5F5F5'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#F5F5F5',
        backgroundColor: '#F5F5F5',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'left',
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 10,
        paddingLeft:5
    },
    // refrence: {
    //     width: '20%',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    // },
    description: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    details: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    service_date: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    // rate: {
    //     width: '15%',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    // },
    amount: {
        width: '25%',
        textAlign: 'center',
    },
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        {/* <Text style={styles.refrence}>Booking ID</Text> */}
        <Text style={styles.description}>Supplier</Text>
        <Text style={styles.details}>Details</Text>
        <Text style={styles.service_date}>Start/End Date</Text>
        <Text style={styles.amount}>Pricing</Text>
        {/* <Text style={styles.rate}>@</Text>
        <Text style={styles.amount}>Amount</Text> */}
    </View>
    
    
  );
  
  export default InvoiceTableHeader